type OpenFileBySignedUrlParams = {
  document_name?: string;
  dispatch: any;
  getSignedUrlThunk: (payload: { document_name: string }) => any;
};

export const openFileBySignedUrl = async ({
  document_name,
  dispatch,
  getSignedUrlThunk,
}: OpenFileBySignedUrlParams) => {
  if (!document_name) {
    alert("Document not found.");
    return;
  }

  try {
    const result = await dispatch(getSignedUrlThunk({ document_name }));

    const signedUrl = result?.payload?.data?.signedUrl;

    if (signedUrl) {
      window.open(signedUrl, "_blank", "noopener,noreferrer");
    } else {
      alert("Unable to fetch file URL.");
    }
  } catch (error) {
    console.error("Signed URL fetch failed", error);
    alert("Something went wrong while opening the file.");
  }
};

export const getSignedPreviewUrl = async ({
  document_name,
  dispatch,
  getSignedUrlThunk,
}: {
  document_name?: string;
  dispatch: any;
  getSignedUrlThunk: (payload: { document_name: string }) => any;
}) => {
  if (!document_name) return undefined;

  const result = await dispatch(getSignedUrlThunk({ document_name })).unwrap();
  return result?.data?.signedUrl;
};

export const getActualFileName = (fileName: string) => {
  if (!fileName || typeof fileName !== "string") return "";

  // remove first two prefixes: <timestamp>-<random>-
  return fileName.split("-").slice(2).join("-");
};
